// tanstack
import { createFileRoute, Outlet, useParams } from '@tanstack/react-router';

// api
import { useUnitsGetAsyncByidQuery } from '@/api/generated/recalc/endpoints/v1/units';

// components
import { useBreadcrumb } from '@/hooks/useBreadcrumb';

export const Route = createFileRoute('/$accountId/_user/units/$unitId')({
  component: RouteComponent,
});

function RouteComponent() {
  const { unitId } = useParams({ strict: false });

  const { data: unit } = useUnitsGetAsyncByidQuery(
    { id: Number(unitId) },
    { skip: !unitId },
  );

  useBreadcrumb(unit?.Name ?? '');

  return <Outlet />;
}
